import { Cog, IdCard, LucideUndo2 } from 'lucide-react'

import { Button } from '../ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'
import { unonboard } from './un-onboard'

import { IS_DEV } from '@/env'
import { useAuthenticatedUser } from '@/state/session'

export function DebugDropdown() {
  const { profile } = useAuthenticatedUser()

  if (!IS_DEV) {
    return null
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild className="select-none">
        <Button variant={'ghost'} size={'icon'}>
          <Cog className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
        sideOffset={4}
      >
        <DropdownMenuGroup>
          <DropdownMenuItem>
            <IdCard className="size-3.5 mr-2" />
            <span
              className="truncate text-xs cursor-pointer"
              onClick={() => {
                navigator.clipboard.writeText(profile.id)
              }}
            >
              {profile.id}
            </span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => unonboard(profile.id)} className="cursor-pointer">
            <LucideUndo2 className="size-3.5 mr-2" />
            Un-onboard
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
